import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { translations, LANGUAGES } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "villa-sucuraj-lang";

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    const saved = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (saved && translations[saved]) {
      setLang(saved);
    }
  }, []);

  const changeLang = (code) => {
    if (!translations[code]) return;
    setLang(code);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, code);
    }
  };

  const value = useMemo(
    () => ({
      lang,
      setLang: changeLang,
      t: translations[lang],
      languages: LANGUAGES,
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
